import React from 'react';

const TeamLoginMinimal = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#f3f4f6'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <h1 style={{ textAlign: 'center', marginBottom: '1rem' }}>
          BookingFlows Team Portal
        </h1>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '2rem' }}>
          Coming Soon...
        </p>
        <div style={{ textAlign: 'center' }}>
          <a 
            href="/login" 
            style={{
              color: '#2563eb',
              textDecoration: 'underline'
            }}
          >
            Admin Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default TeamLoginMinimal;